import { render, staticRenderFns } from "./BookingSingle.vue?vue&type=template&id=ef0b33dc"
import script from "./BookingSingle.vue?vue&type=script&lang=js"
export * from "./BookingSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports